import { MERCHANT_SAMPLE_COST_MAX_DECIMAL_DIGITS } from 'constants/settings';

export function roundMoney(n: number): number {
  return Math.round(n * 100) / 100;
}

export function moneyEquals(a: number | null, b: number): boolean {
  const ca = a === null ? null : Math.round(a * 100);
  const cb = Math.round(b * 100);
  return ca === cb;
}

export function sampleCostToApiValue(parsed: number): string {
  return roundMoney(parsed).toFixed(MERCHANT_SAMPLE_COST_MAX_DECIMAL_DIGITS);
}
